/*global Modernizr, Splide, TLASlideCurrentSlide, TLASlideHideArrows, TLASlideDisableDrag */
/*jslint browser:true */

(function() {
    'use strict';

  var sponsor_containers = document.querySelectorAll('.sponsor-container');

  if(sponsor_containers) {
    sponsor_containers.forEach((sponsor_container) => {
      const sponsor_slider = sponsor_container.querySelector('.sponsor-slider'),
            slider = new Splide(sponsor_slider, {
              type: 'slide',
              arrows: 'slider',
              pagination: false
            });

      // var numSlides = $(this).children().length,
      //     centerMode = true;

      // if(numSlides <= 5) {
      //   centerMode = false;
      // }

      // $(this).slick({
      //   slidesToShow: 5,
      //   centerMode: centerMode,
      //   centerPadding: '0',
      //   prevArrow: '<span class="arrow-prev"><svg class="icon" viewBox="0 0 24 24"><use xlink:href="#banner-arrow"></use></svg></span>',
      //   nextArrow: '<span class="arrow-next"><svg class="icon" viewBox="0 0 24 24"><use xlink:href="#banner-arrow"></use></svg></span>',
      //   responsive: [
      //     {
      //       breakpoint: 1050,
      //       settings: {
      //         slidesToShow: 4
      //       }
      //     },
      //     {
      //       breakpoint: 900,
      //       settings: {
      //         slidesToShow: 3
      //       }
      //     },
      //     {
      //       breakpoint: 780,
      //       settings: {
      //         slidesToShow: 2
      //       }
      //     }
      //   ]
      // });

      slider.mount({ TLASlideCurrentSlide, TLASlideHideArrows, TLASlideDisableDrag });
    });
  }
}());
